import React, { useEffect, useState } from 'react';
import { getTemplatesByMode,login } from '../api/api';

function StorySelect() {
  const [templates, setTemplates] = useState([]);

  useEffect(() => {
    async function fetchTemplates() {
      try {
        let token = localStorage.getItem('access_token');
        if (!token) {
          const loginResponse = await login(); // 假设 login 函数返回一个包含 token 的对象
          console.log(loginResponse);
          token = loginResponse.data.access_token;
          localStorage.setItem('access_token', token);
        }

        let data = await getTemplatesByMode('男生', token); // 假设 'default' 是一个有效的 modeType
        if (data === 401) {
          const loginResponse = await login(); // 重新登录获取新的 token
          console.log(loginResponse);
          token = loginResponse.data.access_token;
          localStorage.setItem('access_token', token);
          data = await getTemplatesByMode('男生', token); // 使用新的 token 重新获取数据
        }
        
        setTemplates(data);
        console.log(data);
      } catch (error) {
        console.error('Error fetching templates:', error);
      }
    }

    fetchTemplates();
  }, []);

    function handleTemplateClick(template) {
        template.checked = !template.checked;
        setTemplates([...templates]);

        // 获取所有选中的模板名称
        const selectedTemplateNames = templates
        .filter(t => t.checked)
        .map(t => t.name);

        // 将选中的模板名称存储到 localStorage
        localStorage.setItem('selectedTemplateNames', JSON.stringify(selectedTemplateNames));
    }

  return (
    <div style={{
      backgroundImage: 'url(/images/background.png)', // 使用相对于 public 目录的路径
      backgroundSize: 'cover',
      height: '100vh',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      flexDirection: 'column',
      overflow: 'hidden' // 设置超出隐藏
    }}>
      <img src="/images/title.png" alt="Title" style={{
        position: 'absolute',
        top: '10px',
        left: '30px',
        width: '60px'
      }} />
      <div style={{
        position: 'absolute',
        top: '25px',
        right: '40px',
        fontWeight: 'bold',
        fontSize: '18px'
      }}>
        故事模板选择
      </div>

      <div 
        style={{ 
          position:'fixed',
          top:'80px',
          fontSize: '12px', 
          marginBottom: '10px', 
          fontWeight: 500 
        }}
      >
        请选择在短剧中需要出现的故事模板，故事模板可以选择多个
      </div>

    <div style={{
      display: 'flex',
      flexWrap: 'wrap',
      position:'fixed',
      top:'0px',
      marginTop: '120px',
    }}>
      {templates.map(template => (
        <div 
          key={template.id}
          style={{
            width: '100px',
            height: '150px',
            backgroundColor: template.checked ? '#F65555' : 'white',
            border: '1px solid #ccc',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            cursor: 'pointer',
            borderRadius: '15px',
            padding: '20px',
            margin: '10px'
          }}
          onClick={() => handleTemplateClick(template)}
        >
          <span style={{ fontSize: '18px', marginTop: '5px' }}>{template.name}</span>
          <span style={{ fontSize: '12px', marginTop: '60px', color: 'rgba(128, 128, 128, 0.5)', overflow: 'auto', textOverflow: 'ellipsis', whiteSpace: 'normal', display: 'block', width: '80px', height: '100px' }}>简介：{template.mode_description}</span>
        </div>
      ))}
    </div>
    <button 
          onClick={() => window.location.href = '/story-setting'}
          style={{
            position: 'fixed',
            bottom: '50px',
            padding: '10px 20px',
            fontSize: '16px',
            width: '55%',
            height: '80px',
            backgroundColor: 'black',
            color: 'white',
            border: 'none',
            borderRadius: '5px',
            cursor: 'pointer'
          }}>
          下一步
    </button>
    </div>
  );
}

export default StorySelect;
